import reducer from "./reducer";
export { default as CategoriesAndSpecialties } from "./components/index";
export { default as categoriesAndSpecialtiesReducerName } from "./constants";
export default reducer;
